
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12.6499 10C11.6999 7.31 8.89994 5.5 5.76994 6.12C3.47994 6.58 1.61994 8.41 1.13994 10.7C0.31994 14.57 3.25994 18 6.99994 18C9.60994 18 11.8299 16.33 12.6499 14H16.9999V16C16.9999 17.1 17.8999 18 18.9999 18C20.0999 18 20.9999 17.1 20.9999 16V14C22.0999 14 22.9999 13.1 22.9999 12C22.9999 10.9 22.0999 10 20.9999 10H12.6499ZM6.99994 14C5.89994 14 4.99994 13.1 4.99994 12C4.99994 10.9 5.89994 10 6.99994 10C8.09994 10 8.99994 10.9 8.99994 12C8.99994 13.1 8.09994 14 6.99994 14Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-vpn-key`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconVpnKey

    ```js
    <b-new-b-icon-vpn-key />
    ```
</docs>


